import ApiService from './ApiService';

class UsersService extends ApiService {
    constructor() {
        super();

        this._locale = 'ru';
        this._usersUrl = '/users/';
        this._buyersUrl = '/users/buyers';
        this._detailsUrl = '/users/details';
        this._newUsersUrl = '/users/new';
        this._sellersUrl = '/users/sellers';
        this._buyersHeadersUrl = '/users/table-data/buyers';
        this._newUsersHeadersUrl = '/users/table-data/new';
        this._sellersHeadersUrl = '/users/table-data/sellers';
        this._updateUrl = '/users/update/';
        this._updateExtendedUrl = '/users/update/extended';
        this._removeUrl = '/users/remove/';
        this._exportBuyersUrl = '/users/export/buyers';
        this._exportNewUsersUrl = '/users/export/new';
    }

    getBuyersHeaders() {
        return this.postResource(this._buyersHeadersUrl, {}, this.getLangHeader())
    }

    getSellersHeaders() {
        return this.postResource(this._sellersHeadersUrl, {}, this.getLangHeader())
    }

    getNewUsersHeaders() {
        return this.postResource(this._newUsersHeadersUrl, {}, this.getLangHeader())
    }

    getUsers(params = {}) {
        return this.postResource(this._usersUrl, params, this.getLangHeader());
    }

    getBuyers(params = {}) {
        const data = { ...params };
        data.filters = {
            ...data.filters,
            is_buyer: 1,
            deleted: 0,
            is_checked: 1,
        }

        return this.postResource(this._buyersUrl, data, this.getLangHeader());
    }

    getSellers(params = {}) {
        const data = { ...params };
        data.filters = {
            ...data.filters,
            is_seller: 1,
            deleted: 0,
            is_checked: 1,
        }

        return this.postResource(this._sellersUrl, data, this.getLangHeader());
    }

    getNewUsers(params) {
        const data = { ...params };
        data.filters = {
            ...data.filters,
            is_checked: 0,
            deleted: 0,
        }

        return this.postResource(this._newUsersUrl, data, this.getLangHeader());
    }

    getDetails(id) {
        return this.postResource(this._detailsUrl, {id}, this.getLangHeader());
    }

    updateParams(param, data) {
        const url = this._updateUrl + param;

        return this.postResource(url, data, this.getLangHeader());
    }

    updateUser(data) {
        return this.postResource(this._updateUrl, data, this.getLangHeader());
    }

    fullUpdateUser(data) {
        return this.postResource(this._updateExtendedUrl, data, this.getBaseHeaders());
    }

    removeUser(data) {
        return this.postResource(this._removeUrl, data, this.getLangHeader());
    }

    buyersExport(params) {
        this._export(this._exportBuyersUrl, params);
    }

    newUsersExport(params) {
        this._export(this._exportNewUsersUrl, params);
    }

    _export(url, params) {
        const query = new URLSearchParams();
        query.append('IDs', JSON.stringify(params));
        window.open(this.getApiPrefix() + `${url}?${query.toString()}`);
    }
}

const service = new UsersService();

export default service;
